/** Persisted collapse state for the V3-P2 portal sidebar (shared between AppLayout and the sidebar). */
export const SIDEBAR_COLLAPSE_KEY = 'cse-sidebar-collapsed'

export function readSidebarCollapsed(): boolean {
  if (typeof window === 'undefined') return false
  return window.localStorage.getItem(SIDEBAR_COLLAPSE_KEY) === '1'
}
